import React from "react"
import { Col, Row } from "react-bootstrap"

import EntityBankAccountsPanel from "@/_components/EntityBankAccountsPanel"
import FormInput from "@/_components/FormInput"
import FormInputExtended from "@/_components/FormInputExtended"
import LayoutCard from "@/_components/LayoutCard"
import { loc } from "@/_services/localization"
import { personTypes } from "@/_services/personUtils"
import { generateRows } from "@/_services/utils"
import AddressesPanel from "@/person/AddressesPanel"
import AddressPanel from "@/person/AddressPanel"
import PersonContacts from "@/person/PersonContacts"
import PersonRegistrationComponent from "@/person/PersonRegistrationComponent"

class PersonGlobal extends React.Component {
  setCompany = patch => {
    const { person, handleSetPersonState } = this.props
    person.company = person.company || {}
    person.company = {
      ...person.company,
      ...patch,
    }

    handleSetPersonState({ company: person.company })
  }

  setWeb = patch => {
    const { person, handleSetPersonState } = this.props
    person.web = person.web || {}
    person.web = {
      ...person.web,
      ...patch,
    }

    handleSetPersonState({ web: person.web })
  }

  getField = col => {
    const { name, colProps: _colProps, formInputProps, hidden, modalRows, inDetails } = col
    if (hidden) return
    const {
      person = {},
      detailed,
      addressExtraInfo,
      addressLanguage,
      addressRegion,
      readOnly,
      modelPath,
      allowDuplicates,
      handleSetPersonState,
      handleSetPersonAddressState,
      showRegistrationConfirmModal,
      isProspect,
      registrationProps = {},
      showSepaMandates,
      fromProspectOrPersonPage,
      showEdit,
      showAddressOpenModalButton,
      showBankOpenModalButton = true,
      personRegistrationsModal,
      query,
    } = this.props

    const isPro = person.type === personTypes.PROFESSIONAL
    const address = person.addresses?.[0] || {}
    const { company } = person || {}
    const { web } = person || {}
    const showPersonAddress = !person.props_address || !person.props_address.hidden
    const showPersonAddresses = person.props_addresses && person.props_addresses.hidden === false
    const showContact = [personTypes.COMPANY, personTypes.ORGANIZATION].includes(person.type)
      ? !person.props_companyContact || !person.props_companyContact.hidden
      : isPro
        ? person.props_proContact && person.props_proContact.hidden === false
        : person.props_individualContact && person.props_individualContact.hidden === false
    const showSecondName = !person.props_secondName || !person.props_secondName.hidden
    const showPhone = (!readOnly || person.phone) && (!person.props_phone || !person.props_phone.hidden)
    const showRegistration = person.props_registration?.hidden !== true
    const showAddressLine = !person.props_addressLine || !person.props_addressLine.hidden
    const showLastName = !person.props_lastName || !person.props_lastName.hidden

    const isRegistrationDisabled = person.props_registration?.disabled === true
    const showName = !person.props_name || !person.props_name.hidden
    const showCurrency = person.props_currency?.hidden === false && this.props.currencies?.length
    const showMobile = !readOnly || person.mobile
    const showEmail = !readOnly || person.email

    let personTitleMd = 1
    if (!showSecondName) personTitleMd += 1

    let firstNameMd = isPro ? 3 : 2
    let lastNameMd = 3
    if (!showSecondName) {
      firstNameMd += 1
      lastNameMd += 1
    }
    if (!showRegistration) {
      firstNameMd += 1
      lastNameMd += 1
    }

    let colProps = _colProps
    if (inDetails && !detailed) {
      colProps ||= {}
      colProps.className = "d-none"
    }
    const registrationColProps = person.props_registration?.colProps || { xs: 12, sm: 6, md: isPro ? 2 : 3 }

    const personProps = { readOnly, modelPath, obj: person, onSetState: handleSetPersonState }
    const companyProps = { ...personProps, obj: company, onSetState: this.setCompany }
    const webProps = { ...personProps, obj: web, onSetState: this.setWeb }

    if (name === "registration")
      return (
        showRegistration && (
          <PersonRegistrationComponent
            readOnly={readOnly}
            person={person}
            personType={person.type}
            label="Registration number"
            onSetState={handleSetPersonState}
            modelPath={modelPath}
            allowDuplicates={allowDuplicates}
            colProps={colProps ?? registrationColProps}
            disabled={isRegistrationDisabled}
            showRegistrationConfirmModal={showRegistrationConfirmModal}
            isProspect={isProspect}
            query={query}
            {...registrationProps}
            {...(person?.props_registration || {})}
            fromProspectOrPersonPage={fromProspectOrPersonPage}
            showEdit={showEdit}
            {...formInputProps}
            modalRows={modalRows}
            personRegistrationsModal={personRegistrationsModal}
            key={name}
          />
        )
      )
    else if (name === "title")
      return (
        <FormInput
          field="title"
          select="personTitle"
          colProps={colProps ?? { xs: 12, md: personTitleMd }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "firstName")
      return (
        <FormInput debounce field="firstName" colProps={colProps ?? { xs: 12, md: firstNameMd }} {...personProps} {...formInputProps} key={name} />
      )
    else if (name === "lastName")
      return (
        showLastName && (
          <FormInput
            mandatory
            debounce
            field="lastName"
            colProps={colProps ?? { xs: 12, md: lastNameMd }}
            {...personProps}
            {...formInputProps}
            key={name}
          />
        )
      )
    else if (name === "secondName")
      return (
        showSecondName && (
          <FormInput debounce field="secondName" colProps={colProps ?? { xs: 12, md: lastNameMd }} {...personProps} {...formInputProps} key={name} />
        )
      )
    else if (name === "phone")
      return (
        showPhone && (
          <FormInput debounce field="phone" type="phone" colProps={colProps ?? { xs: 12, sm: 3 }} {...personProps} {...formInputProps} key={name} />
        )
      )
    else if (name === "mobile")
      return (
        showMobile && (
          <FormInput debounce field="mobile" type="phone" colProps={colProps ?? { xs: 12, sm: 3 }} {...personProps} {...formInputProps} key={name} />
        )
      )
    else if (name === "email")
      return (
        showEmail && (
          <FormInput debounce field="email" type="email" colProps={colProps ?? { xs: 12, sm: 3 }} {...personProps} {...formInputProps} key={name} />
        )
      )
    else if (name === "preferredLanguage")
      return (
        <FormInput
          field="preferredLanguage"
          select="preferredLanguage"
          colProps={colProps ?? { xs: 12, sm: 3 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "addressLine")
      return (
        showAddressLine &&
        !detailed && (
          <FormInputExtended
            obj={address}
            type="address"
            readOnly={readOnly}
            extraInfo={addressExtraInfo}
            language={addressLanguage}
            region={addressRegion}
            onSetState={handleSetPersonAddressState}
            colProps={colProps ?? { xs: 12 }}
            modelPath={modelPath}
            {...formInputProps}
            key={name}
          />
        )
      )
    else if (name === "birthDate")
      return (
        <FormInput
          field="birthDate"
          isBirthDate
          type="date"
          colProps={colProps ?? { xs: 12, sm: 3, className: detailed ? "" : "d-none" }}
          timeZone="Europe/London"
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "birthPlace")
      return (
        <FormInput
          field="birthPlace"
          colProps={colProps ?? { xs: 12, sm: 3, className: detailed ? "" : "d-none" }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "birthZipcode")
      return (
        <FormInput
          field="birthZipcode"
          colProps={colProps ?? { xs: 12, sm: 3, className: detailed ? "" : "d-none" }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "birthCountry")
      return (
        <FormInput
          field="birthCountry"
          select="country"
          colProps={colProps ?? { xs: 12, sm: 3, className: detailed ? "" : "d-none" }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "nationality")
      return (
        <FormInput
          field="nationality"
          select="country"
          colProps={colProps ?? { xs: 12, sm: 3, className: detailed ? "" : "d-none" }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "contacts")
      return (
        showContact && (
          <Col key={name} xs={12} {...(colProps || {})}>
            <PersonContacts
              show={detailed}
              person={person}
              collapse={false}
              readOnly={readOnly}
              handleSetPersonState={handleSetPersonState}
              {...formInputProps}
            />
          </Col>
        )
      )
    else if (name === "address")
      return (
        showPersonAddress && (
          <Col key={name} xs={12} {...(colProps || {})}>
            <AddressPanel
              entity={person}
              handleSetEntityState={handleSetPersonState}
              readOnly={readOnly}
              extraInfo={addressExtraInfo}
              language={addressLanguage}
              region={addressRegion}
              modelPath={modelPath}
              show={detailed}
              showOpenModalButton={showAddressOpenModalButton}
            />
          </Col>
        )
      )
    else if (name === "addresses")
      return (
        showPersonAddresses && (
          <Col key={name} xs={12} {...(colProps || {})}>
            <AddressesPanel
              entity={person}
              handleSetEntityState={handleSetPersonState}
              readOnly={readOnly}
              extraInfo={addressExtraInfo}
              language={addressLanguage}
              region={addressRegion}
              modelPath={modelPath}
              show={detailed}
              showOpenModalButton={showAddressOpenModalButton}
            />
          </Col>
        )
      )
    else if (name === "bankAccounts") {
      if (person?.props_bankAccounts?.hidden) return null
      return (
        <Col key={name} xs={12} {...(colProps || {})}>
          <EntityBankAccountsPanel
            entity={person}
            hidden={!detailed}
            readOnly={readOnly}
            entityName="Person"
            modelPath={modelPath}
            showModal={showBankOpenModalButton}
            showSepaMandates={showSepaMandates}
            handleSetEntityState={handleSetPersonState}
          />
        </Col>
      )
    } else if (name === "familyMaritalStatus")
      return (
        <FormInput
          field="familyMaritalStatus"
          label={loc`Marital status`}
          select="maritalStatus"
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "familyMaritalContract")
      return (
        <FormInput
          field="familyMaritalContract"
          label={loc`Marital contract`}
          select="maritalContract"
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "familyNumberOfDependents")
      return (
        <FormInput
          field="familyNumberOfDependents"
          label={loc`Number of dependents`}
          type="number"
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "employmentJobDescription")
      return (
        <FormInput
          field="employmentJobDescription"
          label={loc`Job description`}
          select="jobDescription"
          colProps={colProps ?? { xs: 12, sm: person?.props_employmentSector?.hidden ? 12 : 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "employmentSector")
      return (
        <FormInput
          field="employmentSector"
          select="employmentSector"
          colProps={colProps ?? { xs: 12, sm: person?.props_employmentJobDescription?.hidden ? 12 : 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "employmentContractType")
      return (
        <FormInput
          field="employmentContractType"
          select="employmentContractType"
          label={loc`Contract type`}
          colProps={colProps ?? { xs: 12, sm: person?.props_employmentStartDate?.hidden ? 12 : 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "employmentStartDate")
      return (
        <FormInput
          field="employmentStartDate"
          type="date"
          onSetState={handleSetPersonState}
          colProps={colProps ?? { xs: 12, sm: person?.props_employmentContractType?.hidden ? 6 : 3 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "employmentEndDate")
      return (
        <FormInput
          field="employmentEndDate"
          type="date"
          onSetState={handleSetPersonState}
          colProps={colProps ?? { xs: 12, sm: person?.props_employmentContractType?.hidden ? 6 : 3 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "incomeSource")
      return (
        <FormInput
          field="incomeSource"
          label={loc`Source of income`}
          select="incomeSource"
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "incomeSalary")
      return (
        <FormInput
          field="incomeSalary"
          label={loc`Salary`}
          type="currency"
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "incomeHousing")
      return (
        <FormInput
          field="incomeHousing"
          label={loc`Housing income`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "incomeAllocation")
      return (
        <FormInput
          field="incomeAllocation"
          label={loc`Allocation received`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "incomeOther")
      return (
        <FormInput
          field="incomeOther"
          label={loc`Other income`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "incomeTotal")
      return (
        <FormInput
          field="incomeTotal"
          label={loc`Total income`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "expenditureHousingMonthlyRental")
      return (
        <FormInput
          field="expenditureHousingMonthlyRental"
          label={loc`Rental`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "expenditureHousingMortgageRepayment")
      return (
        <FormInput
          field="expenditureHousingMortgageRepayment"
          label={loc`Mortgage repayment`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "expenditureOtherLoanRepayment")
      return (
        <FormInput
          field="expenditureOtherLoanRepayment"
          label={loc`Other loans`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "expenditureAlimony")
      return (
        <FormInput
          field="expenditureAlimony"
          label={loc`Child maintenance`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "expenditureTaxes")
      return (
        <FormInput
          field={name}
          label={loc`Taxes (monthly)`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "expenditureTotal")
      return (
        <FormInput
          field={name}
          label={loc`Total expenditure`}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6 }}
          {...personProps}
          {...formInputProps}
          key={name}
        />
      )
    else if (name === "name")
      return (
        showName && (
          <FormInput mandatory field="name" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...personProps} {...formInputProps} key={name} />
        )
      )
    else if (name === "commercialName")
      return <FormInput field={name} colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...personProps} {...formInputProps} key={name} />
    else if (name === "legalForm")
      return (
        <FormInput field={name} select="legalForm" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...personProps} {...formInputProps} key={name} />
      )
    else if (name === "currency")
      return (
        showCurrency && (
          <FormInput
            colProps={colProps ?? { xs: 12, sm: 3 }}
            field="currency"
            select={this.props.currencies}
            {...personProps}
            {...formInputProps}
            key={name}
          />
        )
      )
    else if (name === "creationDate")
      return (
        <FormInput
          field={name}
          label={loc`Date of creation`}
          type="date"
          colProps={colProps ?? { xs: 12, sm: 6, md: 3 }}
          {...companyProps}
          key={name}
        />
      )
    else if (name === "registrationDate")
      return (
        <FormInput
          field={name}
          label={loc`Date of registration`}
          type="date"
          colProps={colProps ?? { xs: 12, sm: 6, md: 3 }}
          {...companyProps}
          key={name}
        />
      )
    else if (name === "shareCapital")
      return <FormInput field="shareCapital" type="currency" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "registrationCountry")
      return <FormInput field="registrationCountry" select="country" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "registrationPlace")
      return <FormInput field="registrationPlace" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "registrationInfo")
      return <FormInput field="registrationInfo" colProps={colProps ?? { xs: 12, sm: 6 }} {...companyProps} key={name} />
    else if (name === "vatScheme")
      return (
        <FormInput
          label={loc`VAT scheme`}
          field="vatScheme"
          select="vatScheme"
          colProps={colProps ?? { xs: 12, sm: 6, md: 3 }}
          {...companyProps}
          key={name}
        />
      )
    else if (name === "activityCode")
      return (
        <FormInput
          field="activityCode"
          select="activityCode"
          colProps={colProps ?? { xs: 12, sm: 6, md: 3 }}
          {...personProps}
          modelPath={modelPath}
          key={name}
        />
      )
    else if (name === "naceCode")
      return (
        <FormInput
          label={loc`NACE code`}
          field="naceCode"
          select="naceCode"
          colProps={colProps ?? { xs: 12, sm: 6, md: 3 }}
          {...companyProps}
          key={name}
        />
      )
    else if (name === "sectorCode")
      return <FormInput field="sectorCode" select="sectorCode" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "insuranceNumber")
      return <FormInput field="insuranceNumber" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "legalRepresentative")
      return <FormInput field="legalRepresentative" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "administrativeStatus")
      return <FormInput field={name} colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} select="administrativeStatus" {...companyProps} key={name} />
    else if (name === "yearOfReference")
      return <FormInput field={name} colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "companySize")
      return <FormInput field="companySize" select="companySize" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "nbOfEmployees")
      return <FormInput field={name} type="number" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "accountingStandards")
      return <FormInput field={name} select="accountingStandards" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "totalBalancesheet")
      return <FormInput field={name} type="currency" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "totalTurnover")
      return (
        <FormInput
          field={name}
          type="currency"
          //TODO add currency props
          colProps={colProps ?? { xs: 12, sm: 6, md: 3 }}
          {...companyProps}
          key={name}
        />
      )
    else if (name === "legalProceedingsStatus")
      return <FormInput field={name} select="legalStatusCode" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "dateLegalProceeding")
      return <FormInput field={name} type="date" colProps={colProps ?? { xs: 12, sm: 6, md: 3 }} {...companyProps} key={name} />
    else if (name === "website") return <FormInput field={name} colProps={colProps ?? { xs: 12, sm: 6 }} {...webProps} key={name} />
    else if (name === "linkedIn") return <FormInput field={name} label="LinkedIn" colProps={colProps ?? { xs: 12, sm: 6 }} {...webProps} key={name} />
    else if (name === "facebook") return <FormInput field={name} colProps={colProps ?? { xs: 12, sm: 6 }} {...webProps} key={name} />
    else if (name === "instagram") return <FormInput field={name} colProps={colProps ?? { xs: 12, sm: 6 }} {...webProps} key={name} />
    else if (name) return <FormInputExtended field={name} colProps={colProps ?? { xs: 12 }} {...personProps} {...formInputProps} key={name} />
  }
  render() {
    const {
      person = {},
      tabPerson,
      detailed,
      readOnly,
      layout = {},
      modelPath,
      tabPersonModelPath,
      usePersonLayout,
      useProspectLayout,
      handleSetPersonState,
      handleSetTabPersonState,
      rows,
      isProspect,
    } = this.props

    const layoutCards =
      usePersonLayout || useProspectLayout
        ? layout.cards
            ?.filter(card => !card.props?.hidden && card.card !== "Person")
            .map((card, index) => {
              const { props = {} } = card
              const { colProps, useParentEntityPerson } = props
              const { xs = 12, sm, md, lg } = colProps || {}
              props.noCard = true
              return (
                <Col {...{ xs, sm, md, lg }} key={index}>
                  <LayoutCard
                    key={index}
                    card={card}
                    serverRoute={`/api/person/${isProspect ? "prospects" : "persons"}`}
                    readOnly={readOnly}
                    onSetState={useParentEntityPerson ? handleSetTabPersonState : handleSetPersonState}
                    {...(props || {})}
                    entity={useParentEntityPerson ? tabPerson : person}
                    noCard
                    modelPath={useParentEntityPerson ? tabPersonModelPath : modelPath}
                  />
                </Col>
              )
            })
        : []

    return (
      <div className="person-global">
        {generateRows({ getField: this.getField, rows, entity: person, handleSetState: handleSetPersonState, modelPath, readOnly })}
        {detailed && layoutCards?.length > 0 && <Row>{layoutCards}</Row>}
      </div>
    )
  }
}

export default PersonGlobal
